Array.prototype.append = (el) ->
  this.push el if this.push?
  this

myElement = document.querySelector("header")
headroom  = new Headroom(myElement,
  offset: 128
  classes: 
    notTop: "header--not-top"
)
headroom.init()

new WOW({offset: 400}).init()

document.addEventListener 'DOMContentLoaded', () ->

  popoverTriggerList = document.querySelectorAll('.nav-link[data-content-id]')
  [...popoverTriggerList].map((popoverTriggerEl, index, triggersArray) ->
    
    offsetX = switch index
      when 0 then 300
      when 1 then 175
      when 2 then 100
      when 3 then -75
      when 4 then -250
      when 5 then -150
      else 0

    pci =  $(popoverTriggerEl).data("content-id")
    new bootstrap.Popover(popoverTriggerEl, {
      placement: 'bottom'
      html: true
      trigger: 'manual'
      container: $(popoverTriggerEl).parent()
      content: document.getElementById("popoper-content-#{pci}")
      offset: [offsetX, 50]
      customClass: 'tips-popover'
    })

  )

